import { render, staticRenderFns } from "./Quota.vue?vue&type=template&id=f891e0bc"
import script from "./Quota.vue?vue&type=script&lang=js"
export * from "./Quota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports